import { useTranslation } from 'react-i18next';
import { ButtonRow, ApplyButton, CancelButton } from './PromoCodeDrawer.style';

const PromoCodeDrawerFooter: React.FC<{
  isPromoApplied: boolean;
  loading: boolean;
  promoCode: string;
  closeDrawer: () => void;
  onApply: () => void;
}> = ({ isPromoApplied, loading, promoCode, onApply, closeDrawer }) => {
  const { t } = useTranslation();

  return (
    <ButtonRow>
      {isPromoApplied ? (
        <ApplyButton variant="secondary" width={[1]} onClick={closeDrawer}>
          {t('promo.continue')}
        </ApplyButton>
      ) : (
        <>
          <CancelButton
            variant="naked"
            width={[1, null, 1 / 2]}
            display={['none', null, 'block']}
            onClick={closeDrawer}
          >
            {t('promo.cancel')}
          </CancelButton>

          <ApplyButton
            variant="secondary"
            width={[1, null, 1 / 2]}
            onClick={onApply}
            disabled={loading || !promoCode}
            data-testid="promo-apply-btn"
          >
            {t('promo.apply')}
          </ApplyButton>
        </>
      )}
    </ButtonRow>
  );
};

export default PromoCodeDrawerFooter;
